import type { FieldMergeFunction } from '@apollo/client'

const merge: FieldMergeFunction<ClientVersion[]> = (existing, incoming) => {
  return incoming
}

export default {
  merge,
}
